/**
 * Chouchous custom filter bar JS
 * - Exclusive dropdowns (close others when one opens)
 * - Category sub-nav: redirect on checkbox change
 * - Afficher/Fermer le menu sidebar toggle
 */

(function () {
  'use strict';

  // ── Exclusive dropdowns ──────────────────────────────────────────────────
  // When a filter <details> opens, close all other filter <details>
  function initExclusiveDropdowns() {
    const filterItems = document.querySelectorAll('.ch-filter-item');
    const isDesktop = window.matchMedia('(min-width: 990px)');

    function closeItem(item) {
      item.removeAttribute('open');
      const summary = item.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'false');
    }

    function openItem(item) {
      filterItems.forEach(function (other) {
        if (other !== item && other.open) {
          closeItem(other);
        }
      });

      item.setAttribute('open', '');
      const summary = item.querySelector('summary');
      if (summary) summary.setAttribute('aria-expanded', 'true');
    }

    filterItems.forEach(function (item) {
      if (item.dataset.chHoverBound === 'true') return;
      item.dataset.chHoverBound = 'true';

      item.addEventListener('toggle', function () {
        if (item.open) {
          filterItems.forEach(function (other) {
            if (other !== item && other.open) {
              closeItem(other);
            }
          });
        }
      });

      item.addEventListener('mouseenter', function () {
        if (!isDesktop.matches) return;
        openItem(item);
      });

      item.addEventListener('mouseleave', function () {
        if (!isDesktop.matches) return;
        closeItem(item);
      });

      item.addEventListener('focusin', function () {
        if (!isDesktop.matches) return;
        openItem(item);
      });

      item.addEventListener('focusout', function () {
        if (!isDesktop.matches) return;
        setTimeout(function () {
          if (!item.contains(document.activeElement)) {
            closeItem(item);
          }
        });
      });

      const summary = item.querySelector('summary');
      if (summary) {
        summary.addEventListener('click', function (event) {
          if (!isDesktop.matches) return;
          event.preventDefault();
          openItem(item);
        });
      }
    });

    // Close any open dropdown when clicking outside
    if (document.body.dataset.chFilterOutsideBound !== 'true') {
      document.body.dataset.chFilterOutsideBound = 'true';
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.ch-filter-item')) {
          document.querySelectorAll('.ch-filter-item[open]').forEach(function (item) {
            closeItem(item);
          });
        }
      });
    }
  }

  // ── Category sub-nav: redirect on checkbox click ─────────────────────────
  // When a subcategory checkbox is checked, navigate to that collection URL
  function initCategoryNav() {
    document.querySelectorAll('[data-ch-nav]').forEach(function (input) {
      input.addEventListener('change', function () {
        if (this.checked) {
          window.location.href = this.dataset.chNav;
        }
      });
    });
  }

  // ── Afficher / Fermer le menu sidebar toggle ─────────────────────────────
  function initSidebarToggle() {
    var toggleBtn = document.getElementById('ChMenuToggle');
    var sidebar = document.getElementById('ChCollectionSidebar');
    var layout = document.getElementById('ChCollectionContent');
    var productGrid = document.getElementById('product-grid');

    if (!toggleBtn || !sidebar || !layout) return;

    // Detect the current desktop column count from the grid class
    var colClass = null;
    if (productGrid) {
      for (var i = 0; i < productGrid.classList.length; i++) {
        var cls = productGrid.classList[i];
        if (cls.match(/^grid--\d+-col-desktop$/)) {
          colClass = cls;
          break;
        }
      }
    }

    toggleBtn.addEventListener('click', function () {
      var isOpen = !sidebar.hidden;

      if (isOpen) {
        // Close sidebar
        sidebar.hidden = true;
        layout.classList.remove('ch-sidebar-open');
        toggleBtn.setAttribute('aria-expanded', 'false');

        // Restore original column count
        if (productGrid && colClass) {
          productGrid.classList.remove('grid--3-col-desktop');
          productGrid.classList.add(colClass);
        }

        toggleBtn.querySelector('.ch-menu-toggle__show').hidden = false;
        toggleBtn.querySelector('.ch-menu-toggle__hide').hidden = true;
      } else {
        // Open sidebar
        sidebar.hidden = false;
        layout.classList.add('ch-sidebar-open');
        toggleBtn.setAttribute('aria-expanded', 'true');

        // Switch to 3 columns
        if (productGrid && colClass) {
          productGrid.classList.remove(colClass);
          productGrid.classList.add('grid--3-col-desktop');
        }

        toggleBtn.querySelector('.ch-menu-toggle__show').hidden = true;
        toggleBtn.querySelector('.ch-menu-toggle__hide').hidden = false;
      }
    });
  }

  // ── Desktop sort hover dropdown ──────────────────────────────────────────
  function initSortDropdown() {
    document.querySelectorAll('.ch-sort__dropdown').forEach(function (dropdown) {
      if (dropdown.dataset.chSortBound === 'true') return;
      dropdown.dataset.chSortBound = 'true';

      var select = dropdown.querySelector('.ch-sort__select');
      if (!select) return;

      dropdown.querySelectorAll('[data-ch-sort-value]').forEach(function (optionButton) {
        optionButton.addEventListener('click', function () {
          select.value = this.dataset.chSortValue;
          select.dispatchEvent(new Event('input', { bubbles: true }));
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
    });
  }

  function getMobileFacetsElements() {
    var form = document.getElementById('FacetFiltersFormMobile');

    return {
      disclosure: document.querySelector('.mobile-facets__disclosure'),
      summary: document.querySelector('.mobile-facets__open-wrapper'),
      form: form,
      heading: form ? form.querySelector('[data-ch-mobile-heading]') : null,
      panels: form ? form.querySelectorAll('[data-ch-mobile-panel]') : [],
      sortSelect: form ? form.querySelector('[data-ch-mobile-sort-select]') : null,
      sortButtons: form ? form.querySelectorAll('[data-ch-mobile-sort-value]') : [],
      filtersHeading: form ? form.dataset.chHeadingFilters : '',
      sortHeading: form ? form.dataset.chHeadingSort : ''
    };
  }

  function setMobileView(view) {
    var elements = getMobileFacetsElements();
    if (!elements.form) return;

    var nextView = view === 'sort' ? 'sort' : 'filters';
    elements.form.dataset.chMobileView = nextView;
    elements.form.classList.toggle('mobile-facets--sort-view', nextView === 'sort');
    elements.form.classList.toggle('mobile-facets--filters-view', nextView === 'filters');

    if (elements.heading) {
      elements.heading.textContent = nextView === 'sort' ? elements.sortHeading : elements.filtersHeading;
    }

    elements.panels.forEach(function (panel) {
      var isActivePanel = panel.dataset.chMobilePanel === nextView;
      panel.hidden = !isActivePanel;
      panel.setAttribute('aria-hidden', isActivePanel ? 'false' : 'true');
      panel.style.display = isActivePanel ? 'block' : 'none';
    });
  }

  function syncMobileSortButtons() {
    var elements = getMobileFacetsElements();
    if (!elements.sortSelect) return;

    elements.sortButtons.forEach(function (button) {
      button.classList.toggle('is-active', button.dataset.chMobileSortValue === elements.sortSelect.value);
    });
  }

  function openMobileDrawer(view) {
    var elements = getMobileFacetsElements();
    if (!elements.disclosure || !elements.summary) return;

    setMobileView(view);
    syncMobileSortButtons();

    if (!elements.disclosure.hasAttribute('open')) {
      elements.summary.click();
    }

    window.requestAnimationFrame(function () {
      setMobileView(view);
    });
  }

  function closeMobileDrawer() {
    var elements = getMobileFacetsElements();
    if (!elements.disclosure || !elements.summary) return;

    if (elements.disclosure.hasAttribute('open')) {
      elements.summary.click();
    }
  }

  function bindMobileToolbar() {
    if (document.body.dataset.chMobileToolbarBound === 'true') return;
    document.body.dataset.chMobileToolbarBound = 'true';

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ch-open]');
      if (!button) return;

      openMobileDrawer(button.dataset.chOpen);
    });
  }

  function bindMobileDisclosure() {
    var disclosure = document.querySelector('.mobile-facets__disclosure');
    if (!disclosure || disclosure.dataset.chMobileToggleBound === 'true') return;

    disclosure.dataset.chMobileToggleBound = 'true';
    disclosure.addEventListener('toggle', function () {
      if (!disclosure.hasAttribute('open')) {
        setMobileView('filters');
      }
    });
  }

  function bindMobileSort() {
    if (document.body.dataset.chMobileSortBound === 'true') return;
    document.body.dataset.chMobileSortBound = 'true';

    document.addEventListener('click', function (event) {
      var button = event.target.closest('[data-ch-mobile-sort-value]');
      if (!button) return;

      var elements = getMobileFacetsElements();
      if (!elements.sortSelect) return;

      elements.sortSelect.value = button.dataset.chMobileSortValue;
      syncMobileSortButtons();
      elements.sortSelect.dispatchEvent(new Event('input', { bubbles: true }));
      elements.sortSelect.dispatchEvent(new Event('change', { bubbles: true }));

      setTimeout(function () {
        closeMobileDrawer();
      }, 50);
    });
  }

  // ── Init on DOM ready ────────────────────────────────────────────────────
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-init after Shopify AJAX filter updates
  document.addEventListener('shopify:section:load', init);

  // facets.js dispatches this event after re-rendering
  document.addEventListener('facets:updated', function () {
    initExclusiveDropdowns();
    initCategoryNav();
    initSortDropdown();
    bindMobileToolbar();
    bindMobileDisclosure();
    bindMobileSort();
    syncMobileSortButtons();
    // Don't re-init sidebar toggle (it persists across filter updates)
  });

  function init() {
    initExclusiveDropdowns();
    initCategoryNav();
    initSidebarToggle();
    initSortDropdown();
    bindMobileToolbar();
    bindMobileDisclosure();
    bindMobileSort();
    syncMobileSortButtons();
  }
})();
